@if (getPermission('Sales_Section')?.visible) {
<div class="card p-2">
  <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseSalesSection">
    <a class="card-link flex-fill">RIMS - Sales</a> {{isFormPresent('sales') ? '' : '`'}}
    <i class="fas fa-chevron-up"></i>
  </div>
  <div id="collapseSalesSection" class="collapse show">
    <div class="card-body-section p-4">
@if (!reloadSection) {
  <div class="row" [formGroup]="salesForm">
    <!-- ===============================================COLUMN 1 Begins============================================= -->
    <div class="col-3" style="margin-right: 20px;">
      <!-- column 1 -->
      <div class="row">
        @if (getPermission('Sales_enable')?.visible) {
          <div class="col-6" style="padding-right: 0px; font-size: 0.7rem;">
            <!-- Row 1 Column 1 -->
            <div class="row mb-4">
              <div class="col-12 customLabel">
                <ejs-checkbox #salesEnableCb
                [label]="UPSalesFields.enableDesc" [formControlName]="UPSalesFields.isEnabled"
                [disabled]="!getPermission('Sales_enable')?.enable && isSectionEnabled"
                (change)="onEnableSectionCheckboxChange($event);"></ejs-checkbox>
              </div>
            </div>
          </div>
        }
        @if (getPermission('Sales_resetPreferencesButton')?.visible) {
          <div class="col-4" style="padding: 0px; font-size: 0.7rem;">
            <a href="javascript:" style="text-decoration: none; font-size: 0.7rem;"
            [ngClass]="{'disabledHyperlink': !getPermission('Sales_resetPreferencesButton')?.enable || !isSectionEnabled}"
              (click)="clearPersistence()" title="Reset Persistence"><i class="fas fa-sync pb-2"></i>&nbsp;Reset
              Persistence</a>
          </div>
          }


        @if (getPermission('Sales_rolesDropdown')?.visible) {
          <div class="col-11">
            <!-- Row 1 Column 4 -->
            <div class="row">
              <div class="col-3 customLabel">{{UPSalesFields.roleDesc}}:
              </div>
              <div class="col-9">
                <ejs-dropdownlist #rolesDDL [dataSource]="rolesData"
                  [formControlName]="UPSalesFields.role" [title]="rolesDDL.text || 'Select a Role'"
                  [fields]="{ text: 'displayName', value: 'role' }"
                  [readonly]="getPermission('Sales_rolesDropdown')?.readOnly || !isSectionEnabled"
                  [enabled]="getPermission('Sales_rolesDropdown')?.enable && isSectionEnabled"
                  (change)="onRolesChange($event);" [placeholder]='UPSalesFields.roleDesc'>
                </ejs-dropdownlist>
                <div class="field-error"
                  [ngStyle]="{visibility: (isFormSubmitted && getPermission('Sales_rolesDropdown')?.required && salesForm.controls[UPSalesFields.role].invalid) ? 'visible' : 'hidden'}">
                  Field is required</div>
              </div>
            </div>
          </div>
        }
        @if (getPermission('Sales_startDate')?.visible) {
          <div class="col-11">
            <!-- Row 1 Column 4 -->
            <div class="row">
              <div class="col-3 customLabel">{{UPSalesFields.startDateDesc}}:
                @if (getPermission('Sales_startDate')?.required) {
                <span class="required-asterik">*</span>
                }
              </div>
              <div class="col-9">
                <ejs-datepicker [min]="usersService.getMinStartDate()" [value]="todayDate"
                  [enabled]="getPermission('Sales_startDate')?.enable && isSectionEnabled"
                  [readonly]="getPermission('Sales_startDate')?.readOnly || !isSectionEnabled"
                  [formControlName]="UPSalesFields.startDate" (change)="sectionModified({modified: true, section: UPEnums.SalesFormData}, 'html- startDateChanged');setDateToZeroZero($event, UPSalesFields.startDate);"
                  [placeholder]="UPSalesFields.startDateDesc"></ejs-datepicker>
                  <div class="field-error" [ngStyle]="{visibility: checkDatesFor('SD').isInvalid ? 'visible' : 'hidden'}">{{checkDatesFor('SD')?.message}}</div>
              </div>
            </div>
          </div>
          }
          @if (getPermission('Sales_endDate')?.visible) {
          <div class="col-11">
            <!-- Row 1 Column 4 -->
            <div class="row">
              <div class="col-3 customLabel">{{UPSalesFields.endDateDesc}}:
                @if (getPermission('Sales_endDate')?.required) {
                <span class="required-asterik">*</span>
                }
              </div>
              <div class="col-9">
                <ejs-datepicker [min]="getMaxED()" [value]="todayDate"
                  [enabled]="getPermission('Sales_endDate')?.enable && isSectionEnabled"
                  [readonly]="getPermission('Sales_endDate')?.readOnly || !isSectionEnabled"
                  [formControlName]="UPSalesFields.endDate" (change)="sectionModified({modified: true, section: UPEnums.SalesFormData}, 'html- endDateChanged');setDateToZeroZero($event, UPSalesFields.endDate);"
                  [placeholder]="UPSalesFields.endDateDesc"></ejs-datepicker>
                  <div class="field-error" [ngStyle]="{visibility: checkDatesFor('ED')?.isInvalid ? 'visible' : 'hidden'}">{{checkDatesFor('ED')?.message}}</div>
              </div>
            </div>
          </div>
          }
      </div>
    </div>
    <!-- ===============================================COLUMN 2 Begins============================================= -->
    <div class="col-3" style="margin-right: 20px;">
      <!-- column 2 -->
      <div class="row">
          @if (getPermission('Sales_employeeId')?.visible) {
            <div class="col-11">
              <!-- Row 1 Column 1 -->
              <div class="row">
                <div class="col-3 customLabel">{{UPSalesFields.employeeIdDesc}}:
                  @if (getPermission('Sales_employeeId')?.required ) {
                  <span class="required-asterik">*</span>
                  }
                </div>
                <div class="col-9">

                  <ejs-combobox
                  #employeeIdCombo
                  [sortOrder]="'Ascending'"
                  [allowFiltering]="true"
                  [allowCustom]="false"
                  [filterType]="'contains'"
                  [enabled]="getPermission('Sales_employeeId')?.enable && isSectionEnabled"
                  [readonly]="getPermission('Sales_employeeId')?.readOnly || !isSectionEnabled"
                  [formControlName]="UPSalesFields.employeeId"
                  [dataSource]="employeeIdsData"
                  [fields]="{ text: 'employeeIdDesc', value: 'employeeId' }"
                  (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.SalesFormData}, 'html- employeeIdChanged');  onEmployeeIdChange($safeNavigationMigration($event?.isInteracted), $safeNavigationMigration($event?.itemData))"
                  [placeholder]='UPSalesFields.employeeIdDesc'>
                </ejs-combobox>
                @if(getPermission('Sales_advancedSearchEmployeeId')?.visible) {
                  <a class="advanced-search-button" style="font-size: 0.7rem; float: right;"
                  [ngClass]="{'disabledHyperlink': !getPermission('Sales_advancedSearchEmployeeId')?.enable || !isSectionEnabled}"
                  (click)="getPermission('Sales_advancedSearchEmployeeId')?.enable && isSectionEnabled ? showAdvancedEmployeesSearchPopup = true: false;" href="javascript:" >Advanced Search</a>
                }
                  <div class="field-error"
                    [ngStyle]="{visibility: (isFormSubmitted && getPermission('Sales_employeeId')?.required && salesForm.controls[UPSalesFields.employeeId].invalid) ? 'visible' : 'hidden'}">
                    Field is required</div>
                </div>
              </div>
            </div>
            }

            @if (getPermission('Sales_viewAddress')?.visible) {
              <div class="col-11 mb-2" style="height: 10%;">
                <!-- Column 2 Row 2  -->
                <div class="customer-address disabled-field p-2 border">
                  <div *ngIf="salesForm.controls[UPSalesFields.name]?.value else noAddress;">
                    <div>{{salesForm.controls[UPSalesFields.name]?.value}}</div>
                    <div>{{salesForm.controls[UPSalesFields.address]?.value}}</div>
                    <div>{{getAddressOfUser()}}</div>
                    <div>{{(salesForm.controls[UPSalesFields.country]?.value)}}</div>
                  </div>
                  <ng-template #noAddress>
                    <p class="mt-4 pb-1 fw-normal fst-italic text-center">This user doesn't have any
                      address.</p>
                  </ng-template>
                </div>
              </div>
              }
              @if (getPermission('Sales_mobile')?.visible) {
                <div class="col-11">
                  <!-- Row 1 Column 2 -->
                  <div class="row">
                    <div class="col-3 customLabel">{{UPSalesFields.mobileDesc}}:
                      @if (getPermission('Sales_mobile')?.required) {
                      <span class="required-asterik">*</span>
                      }
                    </div>
                    <div class="col-9">
                       <ejs-textbox trimOnBlur (change)="sectionModified({modified: $event.isInteracted, section: UPEnums.SalesFormData}, 'html- mobileChanged')" style="padding-left: 0px; margin-left: 0px;"
                      [enabled]="getPermission('Sales_mobile')?.enable && isSectionEnabled"
                      [readonly]="getPermission('Sales_mobile')?.readOnly || !isSectionEnabled"
                      [formControlName]="UPSalesFields.mobile"
                        [placeholder]="UPSalesFields.mobileDesc"></ejs-textbox>
                        @if(isFormSubmitted && getPermission('Sales_mobile')?.required &&
                        salesForm.controls[UPSalesFields.mobile].invalid) {
                          <div class="field-error"
                          [ngStyle]="{visibility: (isFormSubmitted && getPermission('Sales_mobile')?.required && salesForm.controls[UPSalesFields.mobile].invalid) ? 'visible' : 'hidden'}">
                          Field is required</div>
                        } @else {
                          <div class="field-error"
                          [ngStyle]="{visibility: (isFormSubmitted && (salesForm.controls[UPSalesFields.mobile].invalid || !isMobileNumberValid)) ? 'visible' : 'hidden'}">
                          Field is Invalid</div>
                        }
                    </div>
                  </div>
                </div>
                }
          @if (getPermission('Sales_email')?.visible) {
          <div class="col-11">
            <!-- Row 2 Column 2 -->
            <div class="row">
              <div class="col-3 customLabel">{{UPSalesFields.emailDesc}}:
                @if (getPermission('Sales_email')?.required) {
                <span class="required-asterik">*</span>
                }
              </div>
              <div class="col-9">
                 <ejs-textbox trimOnBlur="email" (change)="sectionModified({modified: $event.isInteracted, section: UPEnums.SalesFormData}, 'html- emailChanged')"
                  [enabled]="getPermission('Sales_email')?.enable && isSectionEnabled"
                  [readonly]="getPermission('Sales_email')?.readOnly || !isSectionEnabled"
                  [formControlName]="UPSalesFields.email"
                  [placeholder]="UPSalesFields.emailDesc"></ejs-textbox>
                @if(isFormSubmitted && getPermission('Sales_email')?.required &&
                salesForm.controls[UPSalesFields.email].invalid) {
                <div class="field-error"
                  [ngStyle]="{visibility: (isFormSubmitted && getPermission('Sales_email')?.required && salesForm.controls[UPSalesFields.email].invalid) ? 'visible' : 'hidden'}">
                  Field is required</div>
                } @else {
                <div class="field-error"
                  [ngStyle]="{visibility: (isFormSubmitted && (salesForm.controls[UPSalesFields.email].invalid || !isEmailAddressValid)) ? 'visible' : 'hidden'}">
                  Field is Invalid</div>
                }
              </div>
            </div>
          </div>
          }
          @if (getPermission('Sales_isApproved')?.visible || getPermission('Sales_canActAsSalesRep')?.visible) {
            <div class="col-11 mt-3">
              <div class="row">
                <div class="col-12 customLabel">Permissions:</div>
                <div class="col-12">
                  <ejs-listview
                    class="permissions-list"
                    [dataSource]="permissionListItems"
                    [fields]="permissionListFields"
                    [showCheckBox]="true"
                    (select)="onPermissionListSelect($event)">
                    <ng-template #template let-data>
                      <div class="d-flex justify-content-start align-items-center">
                        <span style="margin-right: 6px;">{{data.text}}</span>
                        <span class="e-icons e-circle-info"
                          [title]="data?.tooltipText"
                          (click)="$event.stopPropagation()"></span>
                      </div>
                    </ng-template>
                  </ejs-listview>
                  @if (isFormSubmitted && getPermission('Sales_isApproved')?.required &&
                  salesForm.controls[UPSalesFields.isApprover].invalid) {
                    <div class="field-error">Sales Order Approver is required</div>
                  }
                  @if (isFormSubmitted && getPermission('Sales_canActAsSalesRep')?.required &&
                  salesForm.controls[UPSalesFields.canActAsSalesRep].invalid) {
                    <div class="field-error">Act as Sales Rep is required</div>
                  }
                </div>
              </div>
            </div>
          }
          @if (getPermission('Sales_warehouse')?.visible) {
          <div class="col-11">
            <!-- Row 2 Column 2 -->
            <div class="row">
              <div class="col-3 customLabel">{{UPSalesFields.warehouseDesc}}:
                @if (getPermission('Sales_warehouse')?.required) {
                <span class="required-asterik">*</span>
                }
              </div>
              <div class="col-9">
                  <ejs-combobox
                  #warehouseCombo
                  [sortOrder]="'Ascending'"
                  [allowFiltering]="true"
                  [allowCustom]="false"
                  [filterType]="'contains'"
                  [enabled]="getPermission('Sales_warehouse')?.enable && isSectionEnabled"
                  [readonly]="getPermission('Sales_warehouse')?.readOnly || !isSectionEnabled"
                  [formControlName]="UPSalesFields.warehouse"
                  [dataSource]="warehouseDDL"
                  [fields]="{ text: 'text', value: 'value' }"
                  (select)="onSelect($event)"
                  (change)="sectionModified({modified: $safeNavigationMigration($event?.isInteracted), section: UPEnums.SalesFormData}, 'html- warehouseChanged');"
                  [placeholder]="'Select '+UPSalesFields.warehouseDesc">
                </ejs-combobox>
                @if(isFormSubmitted && getPermission('Sales_warehouse')?.required &&
                salesForm.controls[UPSalesFields.warehouse].invalid) {
                <div class="field-error"
                  [ngStyle]="{visibility: (isFormSubmitted && getPermission('Sales_warehouse')?.required && salesForm.controls[UPSalesFields.warehouse].invalid) ? 'visible' : 'hidden'}">
                  Field is required</div>
                }
              </div>
            </div>
          </div>
          }
      </div>
    </div>
    <div class="col-3" style="margin-right: 20px;">
      <div class="row">
        @if (getPermission('Sales_channels')?.visible) {
          <div class="col-12 mt-4">
            <!-- Column 3 Row 5 -->
            <div class="row">
              <div class="col-12">{{UPSalesFields.channelsDesc}}:
                @if (getPermission('Sales_channels')?.required ) {
                <span class="required-asterik">*</span>
                }
              </div>
              <div class="col-12">
                
                  <div class="sales-channels-grid">
                    <inavista-grid #channelsGrid [config]="channelsGridConfig" (rowsSelected)="onChannelsSelected($event)" />
                  </div>
              </div>
            </div>
          </div>
          }






      </div>
    </div>
  </div>
  @if (getPermission('Sales_assignments')?.visible) {
    <div class="row">
      <div class="col-12">
        <div style="font-weight: bold; font-size: 13px !important; margin: 20px 10px;">Assignments</div>
      </div>
      <div class="col-12">
        <div class="row">
          @if (getPermission('Sales_regions')?.visible) {
            <div class="col-4">
              <app-assignment-grid
              [configs]="regionAssignmentConfigs"
              [isSectionEnabled]="isSectionEnabled"
              (outputSignal)="onOutputSignal($event)"
              ></app-assignment-grid>
            </div>
          }

          @if (getPermission('Sales_districts')?.visible) {
          <div class="col-4">
            <app-assignment-grid
            [configs]="districtAssignmentConfigs"
            [isSectionEnabled]="isSectionEnabled"
            (outputSignal)="onOutputSignal($event)"
            ></app-assignment-grid>
          </div>
        }

        @if (getPermission('Sales_territories')?.visible) {
          <div class="col-4">
            <app-assignment-grid
            [configs]="territoryAssignmentConfigs"
            [isSectionEnabled]="isSectionEnabled"
            (outputSignal)="onOutputSignal($event)"
            ></app-assignment-grid>
          </div>
        }
        </div>
      </div>
    </div>
  }
  @if (getPermission('Sales_preferencesSection')?.visible) {
  <div class="row">
    <div class="col-12 m-auto">
      <div style="font-weight: bold; font-size: 13px !important; margin: 20px 10px;">Preferences</div>
    </div>
    <div class="col-12 control-section">
      <app-up-preferences
      [userProfile]="$safeNavigationMigration(salesForm?.value)"
      [source]="source"
      [configs]="salesPreferencesConfig"
      [isSectionEnabled]="isSectionEnabled"
      [actions]="action"
      (onPreferencesModified)="sectionModified({modified: $event, section: UPEnums.SalesPreferencesData}, 'html- preferencesModified')"
      ></app-up-preferences>
    </div>
  </div>
}
}@else {
    <div class="profile-skeleton">

  <!-- Top Profile Section -->
  <div class="profile-header">
    <!-- <div class="profile-avatar shimmer"></div> -->

    <div class="profile-details">
      <div class="detail-line large shimmer"></div>
      <div class="detail-line shimmer"></div>
      <div class="detail-line shimmer short"></div>

      <div class="detail-grid">
        <div class="detail-item shimmer" *ngFor="let i of [1,2,3,4]"></div>
      </div>
    </div>
  </div>


  <!-- Table Section -->
  <div class="section">
    <div class="section-title shimmer"></div>
    <div class="table-skeleton">
      <div class="table-row shimmer" *ngFor="let i of [1,2]"></div>
    </div>
  </div>

</div>

<div *ngIf="!isLoading">
  <!-- Real profile content -->
</div>
  
}


    </div>
  </div>
</div>
} 







@if (showAdvancedEmployeesSearchPopup) {
  <app-advanced-employee-search-popup
  [configs]="advancedSearchEmployeesConfigurations"
(onClose)="showAdvancedEmployeesSearchPopup = false;"
(onEmployeeSelected)="sectionModified({modified: true, section: UPEnums.SalesFormData}, 'html- advancedEmployeeSelected'); onEmployeeIdChange(true, $event);"

  >

  </app-advanced-employee-search-popup>

}
